import { render, staticRenderFns } from "./orderRefundList.vue?vue&type=template&id=a38d4c64&scoped=true&"
import script from "./orderRefundList.vue?vue&type=script&lang=js&"
export * from "./orderRefundList.vue?vue&type=script&lang=js&"
import style0 from "./orderRefundList.vue?vue&type=style&index=0&id=a38d4c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d4c64",
  null
  
)

export default component.exports